import * as fs from "../utils/formStateUtils";

/* 새 페이지 추가 */
export const addPage = (formStructure) => fs.addNewPage(formStructure);

/* 페이지 삭제 */
export const deletePage = fs.deletePage;

/* 페이지 제목(및 기타 속성) 업데이트 */
export const updatePageTitle = (formStructure, pageId, newTitle) =>
  fs.updatePageTitle(formStructure, pageId, newTitle);

/* 페이지 이동 (동일 레벨 내 reorder) */
export const movePage = fs.movePage;

/* 추가 편의 함수들 (향후 필요 시) */
export const findPageById = fs.findPageById;
